//==============================
// Newsletter Popup
//==============================

var newsletterPopup = $('.newsletter-popup');

function showNewsletter() {
  if ($('.age-gate').hasClass('hidden') || $('.age-gate').length == 0) {
    if (Cookies.get("newsletter") == "SET") {} else {
      setTimeout(function() {
        newsletterPopup.removeClass('hidden');
      }, 1500);
      setTimeout(function() {
        newsletterPopup.find('.newsletter-popup-inner').focus();
      }, 1600);
    }
  }
}

function hideNewsletter() {
  Cookies.set("newsletter", "SET", { expires: 7 });
  newsletterPopup.addClass('hidden');
  setTimeout(function() {
    $('.header').focus();
  }, 1);
}

$(window).on('load', function() {
    if(body.hasClass('home')) {
      showNewsletter(2000);
    } else {
      showNewsletter(0);
    }
});

$('.js-newsletter-popup-close').click(function() {
  hideNewsletter();
  return false;
});

newsletterPopup.click(function() {
  hideNewsletter();
});

newsletterPopup.find('.button').click(function() {
  hideNewsletter();
});

$('.newsletter-popup-inner').click(function(e) {
  e.stopPropagation();
});
